/* Whitelisted storefront events. Google loading and consent enforcement stay in the custom pixel. */
(function () {
  'use strict';

  var lastResult = '';
  var pendingKey = 'merlons.order-request.analytics.v1';
  var sessionWindow = 30 * 60 * 1000;
  var pendingWindow = 60 * 60 * 1000;
  var armedChatUntil = 0;
  var tidioApi;
  var once = Object.create(null);

  function analyticsAllowed() {
    try { return window.Shopify.customerPrivacy.analyticsProcessingAllowed() === true; }
    catch (error) { return false; }
  }

  function storageRead(key) {
    try { return JSON.parse(window.sessionStorage.getItem(key)); }
    catch (error) { return null; }
  }

  function storageWrite(key, value) {
    try { window.sessionStorage.setItem(key, JSON.stringify(value)); return true; }
    catch (error) { return false; }
  }

  function clearPending() {
    try { window.sessionStorage.removeItem(pendingKey); } catch (error) {}
  }

  function publish(name, payload) {
    try {
      if (!analyticsAllowed() || !window.Shopify.analytics || typeof window.Shopify.analytics.publish !== 'function') return false;
      var result = window.Shopify.analytics.publish(name, payload);
      if (result && typeof result.catch === 'function') result.catch(function () {});
      return result !== false;
    } catch (error) { return false; }
  }

  function publishOnce(name, payload, key) {
    if (!analyticsAllowed()) return false;
    var now = Date.now();
    var storageKey = 'merlons.conversion.' + key;
    var previous = once[key] || storageRead(storageKey);
    if (typeof previous === 'number' && now >= previous && now - previous < sessionWindow) return false;
    if (!publish(name, payload)) return false;
    once[key] = now;
    storageWrite(storageKey, now);
    return true;
  }

  function prepareOrderRequest(cart) {
    // The reference is operational; customer contact fields and cart tokens are never read here.
    try {
      clearPending();
      if (!window.crypto || typeof window.crypto.randomUUID !== 'function') return null;
      var id = 'MR-' + window.crypto.randomUUID();
      if (!analyticsAllowed()) return id;
      if (!cart || !Array.isArray(cart.items) || !cart.items.length ||
        !Number.isSafeInteger(cart.total_price) || cart.total_price < 0 ||
        typeof cart.currency !== 'string' || !/^[A-Z]{3}$/.test(cart.currency)) return id;
      var payload = { request_id: id, currency: cart.currency, value_cents: cart.total_price };
      if (Number.isSafeInteger(cart.total_discount) && cart.total_discount >= 0) payload.discount_cents = cart.total_discount;
      var lines = [];
      var total = 0;
      cart.items.slice(0, 201).forEach(function (item) {
        if (!Number.isSafeInteger(item.variant_id) || item.variant_id <= 0 ||
          !Number.isSafeInteger(item.quantity) || item.quantity <= 0 ||
          !Number.isSafeInteger(item.final_line_price) || item.final_line_price < 0) return;
        lines.push({ variant_id: String(item.variant_id), quantity: item.quantity, line_cents: item.final_line_price });
        total += item.final_line_price;
      });
      if (lines.length === cart.items.length && lines.length <= 200 && total === cart.total_price) payload.items = lines;
      storageWrite(pendingKey, { createdAt: Date.now(), payload: payload });
      return id;
    } catch (error) { return null; }
  }

  function confirmOrderRequest() {
    try {
      var state = document.documentElement.getAttribute('data-merlons-order-request-return');
      if (state === 'error') { clearPending(); return; }
      if (state !== 'success' || window.location.hash !== '#MerlonsOrderRequestForm') return;
      var pending = storageRead(pendingKey);
      if (!pending) return;
      if (!Number.isFinite(pending.createdAt) || Date.now() < pending.createdAt || Date.now() - pending.createdAt > pendingWindow) {
        clearPending(); return;
      }
      if (!analyticsAllowed()) return;
      if (publish('merlons_order_request_received', pending.payload)) clearPending();
    } catch (error) {}
  }

  function onStorefrontClick(event) {
    try {
      if (event.isTrusted !== true || event.defaultPrevented) return;
      if (event.type === 'auxclick' && event.button !== 1) return;
      var announcement = event.target.closest('[data-merlons-announcement-link]');
      if (announcement && announcement.getClientRects().length) {
        publish('merlons_announcement_clicked', {
          announcement_id: 'tiles_special_prices', placement: 'announcement_bar'
        });
        return;
      }
      if (event.type === 'auxclick') return;
      var link = event.target.closest('[data-merlons-contact-method]');
      if (!link || !link.closest('details[open]') || !link.getClientRects().length) return;
      var method = link.getAttribute('data-merlons-contact-method');
      if (['phone', 'whatsapp', 'messenger', 'email'].indexOf(method) < 0) return;
      publishOnce('merlons_contact_selected', { contact_method: method, placement: 'header' }, 'header-' + method);
    } catch (error) {}
  }

  function armChatOpen(event) {
    if (event && event.isTrusted === true) armedChatUntil = Date.now() + 10000;
  }

  function attachChatEvents() {
    var api = window.tidioChatApi;
    if (!api || typeof api.on !== 'function' || api === tidioApi) return;
    tidioApi = api;
    api.on('open', function () {
      if (!armedChatUntil || armedChatUntil < Date.now()) return;
      armedChatUntil = 0;
      publishOnce('merlons_chat_opened', { placement: 'floating_widget' }, 'chat-open');
    });
    api.on('conversationStart', function () {
      // Ignore message bodies, visitor details and conversation identifiers.
      publishOnce('merlons_chat_started', { placement: 'floating_widget' }, 'chat-start');
    });
  }

  function reportSearchResults(query, count) {
    try {
      if (typeof query !== 'string' || !query.trim() || !Number.isSafeInteger(count) || count < 0) return;
      if (!window.Shopify || !window.Shopify.analytics || typeof window.Shopify.analytics.publish !== 'function') return;

      // Screen the complete query before truncation; never publish form/contact values.
      var term = query.trim();
      var personal = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/i.test(term) ||
        /(?:^|[^\d])\+?\d[\d\s().-]{7,}\d(?:$|[^\d])/.test(term);
      var payload = { result_count: count };
      if (!personal) payload.search_term = term.slice(0, 100);
      var signature = window.location.pathname + '|' + JSON.stringify(payload);
      if (signature === lastResult) return;
      lastResult = signature;

      var published = window.Shopify.analytics.publish('merlons_collection_search_results', payload);
      if (published && typeof published.catch === 'function') published.catch(function () {});
    } catch (error) {
      // A blocked analytics provider must never interrupt the search interface.
    }
  }

  window.MerlonsAnalytics = {
    reportSearchResults: reportSearchResults,
    prepareOrderRequest: prepareOrderRequest,
    armChatOpen: armChatOpen
  };
  if (typeof document !== 'undefined') {
    document.addEventListener('click', onStorefrontClick, true);
    document.addEventListener('auxclick', onStorefrontClick, true);
    document.addEventListener('tidioChat-ready', attachChatEvents);
    document.addEventListener('visitorConsentCollected', function () {
      if (!analyticsAllowed()) {
        clearPending();
        once = Object.create(null);
        ['header-phone', 'header-whatsapp', 'header-messenger', 'header-email', 'chat-open', 'chat-start'].forEach(function (key) {
          try { window.sessionStorage.removeItem('merlons.conversion.' + key); } catch (error) {}
        });
        return;
      }
      confirmOrderRequest();
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', confirmOrderRequest);
    else confirmOrderRequest();
    attachChatEvents();
    try {
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
          if (!error) confirmOrderRequest();
        });
      }
    } catch (error) {}
  }
})();
